/**
 * Words for QR signature outcomes, from the brand/language dictionary.
 * Falls back to English so a dictionary missing the block never shows blank.
 */
import { QR_VERIFICATION } from './qrVerify.js'

const FALLBACK = {
  verified: 'Ticket signature verified',
  warnInvalid: 'Ticket signature is not valid. Check the ticket in the guest\'s app.',
  warnExpired: 'Ticket code has expired. Ask the guest to reopen their ticket.',
  warnUnknownKey: 'Ticket signature could not be checked on this device.',
  blockedInvalid: 'Not accepted: the ticket signature is not valid. Ask the guest to reopen their ticket in the app.',
  blockedExpired: 'Not accepted: the ticket code has expired. Ask the guest to reopen their ticket in the app.',
  serverInvalid: 'Rejected by the server: the ticket signature is not valid. Ask the guest to reopen their ticket in the app.',
  serverExpired: 'Rejected by the server: the ticket code has expired. Ask the guest to reopen their ticket in the app.',
  serverUnknownKey: 'Rejected by the server: this ticket could not be verified. Ask the guest to reopen their ticket in the app while online.',
  serverUnsigned: 'Rejected by the server: this ticket is not signed. Ask the guest to show the ticket from the app.',
  serverRejected: 'Rejected by the server: the ticket could not be verified.',
}

function dict() {
  try {
    return (typeof __DICT__ !== 'undefined' && __DICT__.qrVerification) || {}
  } catch {
    return {}
  }
}

export function qrText(key) {
  return dict()[key] || FALLBACK[key]
}

/**
 * The message for a server rejection body `{ error, qrVerification }`.
 * @param {{error?: string, qrVerification?: string}} body
 */
export function qrRejectionMessage(body) {
  switch (body?.qrVerification) {
    case QR_VERIFICATION.INVALID: return qrText('serverInvalid')
    case QR_VERIFICATION.EXPIRED: return qrText('serverExpired')
    case QR_VERIFICATION.UNKNOWN_KEY: return qrText('serverUnknownKey')
    case QR_VERIFICATION.UNSIGNED: return qrText('serverUnsigned')
    default: return qrText('serverRejected')
  }
}

/**
 * The scanner's notice for a local result, or null for none.
 * @param {string} verification
 * @param {{block: boolean, warn: boolean, verified: boolean}} decision from qrScanDecision
 * @returns {{type: 'verified'|'warning'|'blocked', text: string}|null}
 */
export function qrNoticeFor(verification, decision) {
  if (!decision) return null
  if (decision.block) {
    return {
      type: 'blocked',
      text: qrText(verification === QR_VERIFICATION.EXPIRED ? 'blockedExpired' : 'blockedInvalid'),
    }
  }
  if (decision.verified) return { type: 'verified', text: qrText('verified') }
  if (decision.warn) {
    const key = verification === QR_VERIFICATION.EXPIRED ? 'warnExpired'
      : verification === QR_VERIFICATION.UNKNOWN_KEY ? 'warnUnknownKey'
        : 'warnInvalid'
    return { type: 'warning', text: qrText(key) }
  }
  return null
}
